<div tabindex="0" (click)="toggleMenu($event)" class="user-info" aria-label="User settings menu">
  <div class="user-info__wrapper">
    <div class="user-info__inner-wrapper">
      <osp-avatar [ariaLabel]="'User avatar'" [icon]="IconKey.TopbarUserSwitcherAvatar | icon"></osp-avatar>
      @if (userProfile$ | async; as userProfile) {
        <p class="text-xs font-semibold text-color">
          {{ userProfile.firstName }}<br /><b>{{ userProfile.lastName }}</b>
        </p>
      }
    </div>

    <i class="text-color" [ngClass]="IconKey.TopbarUserSwitcherDropdown | icon"></i>
  </div>
</div>

<osp-menu #menu [model]="options" [popup]="true"></osp-menu>
